<template>
    <div class="input-group-count">
        <div class="right-btn">
            <button class="btn btn-outline-cart" type="button"
                    @click.prevent="plus()">
                <i class="bi bi-plus"></i>
            </button>
        </div>
        <div class="left-btn">
            <button class="btn btn-outline-cart" type="button"
                    @click.prevent="minus()">
                <i class="bi bi-dash"></i>
            </button>
        </div>
        <input type="text" class="form-control input-outline-cart"
               :class="{'input-cart-danger': this.count > this.max}"
               :value="this.count">
    </div>
</template>

<script>
export default {
    props: ["id", "size", "date", "max", "qty"],

    data: function () {
        return {
            // count: this.qty,
        };
    },

    computed: {
        inCart() {
            if (this.$store.state.cart.items) {
                return this.$store.state.cart.items.find(
                    (x) => x.id == this.id
                );
            } else {
                return false;
            }
        },

        count() {
            let item = this.$store.state.cart.items.find(x => {
                return x.product.id === this.id
            });

            if(!item) {
                return 0;
            }

            if (typeof item.arrivals[this.date] !== 'undefined'
                && typeof item.arrivals[this.date]['cart'] !== 'undefined'
                && typeof item.arrivals[this.date]['cart'][this.size] !== 'undefined'
            ) {
                // console.log(item.arrivals[this.date]['cart'][this.size]);
                return item.arrivals[this.date]['cart'][this.size];
            }

            return 0;
        }
    },

    methods: {

        plus() {
            if (this.count >= this.max) {
                return;
            }

            // this.count++;

            let params = {
                id: this.id,
                size: this.size,
                date: this.date,
            };

            this.$store.dispatch("cart/plus", params);
        },

        minus() {
            if (this.count <= 0) {
                return;
            }

            // this.count--;

            let params = {
                id: this.id,
                size: this.size,
                date: this.date,
            };

            this.$store.dispatch("cart/minus", params);
        },
    },
};
</script>
